import { all, fork } from "redux-saga/effects";
import accessCard from "sagas/accessCard";
import accessLevel from "sagas/accessLevel";
import user from "sagas/user";
import reader from "sagas/reader";
import location from "sagas/location";
import login from "sagas/login";

const reduxModulesSagas = [
  accessCard,
  accessLevel,
  user,
  reader,
  location,
  login
];

function* rootReduxModulesSagas(services = {}) {
  try {
    yield all(reduxModulesSagas.map(saga => fork(saga, services)));
  } catch (error) {
    console.error("reduxModulesSagas - ROOT SAGA ERROR!!!", error);
    console.trace();
  }
}

// single entry point to start all Sagas at once
export default function*(services = {}) {
  try {
    yield all([rootReduxModulesSagas(services)]);
  } catch (error) {
    console.error("ROOT SAGA ERROR!!!", error);
    console.trace();
  }
}



// WEBPACK FOOTER //
// ./src/sagas/index.js